import { DataTable, Dialog, Loader } from "@/components";
import useTaskConfig from "./useTaskConfig";
import { Button } from "@/components/ui";
import { filter } from "@/assets";
import { Filter } from "./Filter";

const TaskConfig = () => {
  const {
    columns,
    onAdd,
    openDeleteDialog,
    setOpenDeleteDialog,
    onConfirmDelete,
    onCancelFilter,
    onFilterBtnClick,
    onRowClick,
    openFilter,
    filterData,
    setFilterData,
    onFilterApply,
    tasksData,
    pageNumber,
    pageSize,
    totalPages,
    totalRecords,
    setPageNumber,
    setPageSize,
    isLoading,
    error,
    isDeleting,
  } = useTaskConfig();

  return (
    <>
      <div className="mb-4 px-5 flex justify-end gap-3">
        <Button type="button" variant="ghost" onClick={onFilterBtnClick}>
          <img src={filter} />
          Filter
        </Button>
        <Button onClick={onAdd}>+ Add New</Button>
      </div>
      {isLoading ? (
        <div className="flex justify-center items-center h-64">
          <Loader />
        </div>
      ) : error ? (
        <div className="flex justify-center items-center h-64">
          <p className="text-red-500">Error loading tasks: {error.message}</p>
        </div>
      ) : (
        <DataTable
          columns={columns}
          data={tasksData}
          onRowClick={onRowClick}
          serviceSidePagination={true}
          pageNumber={pageNumber} // Use 0-based pageNumber
          pageSize={pageSize}
          totalPages={totalPages}
          totalRecords={totalRecords}
          setPageNumber={setPageNumber} // Directly set pageNumber
          setPageSize={setPageSize} // Directly set pageSize
        />
      )}
      {openDeleteDialog && (
        <Dialog
          open={openDeleteDialog}
          setOpen={setOpenDeleteDialog}
          title="Delete Task Config"
          onSave={onConfirmDelete}
          saveText={isDeleting ? "Deleting..." : "Delete"}
          saveBtnClassName="bg-red-600 hover:bg-red-500"
          isLoading={isDeleting}
        >
          <div className="flex flex-col gap-4">
            <p>Are you sure you want to delete this task?</p>
          </div>
        </Dialog>
      )}

      {openFilter && (
        <Filter
          onCancel={onCancelFilter}
          filterData={filterData}
          setFilterData={setFilterData}
          onApply={onFilterApply}
        />
      )}
    </>
  );
};

export default TaskConfig;